import type { AxiosError } from "axios";
import { useSafeConfigValue } from "../../packages/config/safe-config";
import createAuthInterceptor from "../common/createAuthInterceptor";
import createAxiosClient from "../common/createAxiosClient";

import { EOSApiError } from "./exceptions/EOSApiError";
import type { EOSRequestConfig } from "./index.types";
import useOAuthInterceptor from "./middleware/useOAuthInterceptor";
import useReCaptchaInterceptor from "./middleware/useReCaptchaInterceptor";
import useServiceInterceptor from "./middleware/useServiceInterceptor";

const useEOSClient = () =>
	createAxiosClient<EOSRequestConfig>({
		baseURL: useSafeConfigValue("REACT_APP_EOS_ENDPOINT"),
		headers: {
			"X-BRAND": useSafeConfigValue("REACT_APP_EOS_BRAND"),
		},
		onError: (err: AxiosError) => {
			throw new EOSApiError(err);
		},
		requestInterceptors: [
			useServiceInterceptor(),
			createAuthInterceptor(),
			useOAuthInterceptor(),
			useReCaptchaInterceptor(),
		],
	});

export default useEOSClient;
